(function($) {

	"use strict";

	var Accordion = function(el, options) {
		this.$el = $(el);

		var classes = {
			itemClass: 'js-accordion__item',
			triggerClass: 'js-accordion__trigger',
			contentClass: 'js-accordion__content'
		}

		this.settings = $.extend({
			text: '',
			item: '.' + classes.itemClass,
			trigger: '.' + classes.triggerClass,
			content: '.' + classes.contentClass,
			addExpandedClass: '',
			hashNavigation: false,
			speed: 300,
			expanded: false,
			scrollToItem: true,
		}, classes, options, this.$el.data());

		this.settings.addExpandedClass = this.settings.addExpandedClass.split(',');

		this.$items = this.$el.find(this.settings.item);
		this.init();
	};

	Accordion.prototype = {
		init: function () {
			var A = this;

			// Add accordion classes to each item
			A.$items.each(function () {
				var $item = $(this);
				$item.find(A.settings.trigger).addClass(A.settings.triggerClass);
				$item.find(A.settings.content).addClass(A.settings.contentClass);
			})

			A.$el.on('click', A.settings.trigger, function() {
				var $item = $(this).closest(A.settings.item);

				if ($item.hasClass('expanded')) {
					A.contract($item);
				} else if (!A.expandUsingHash($item)) {
					A.expand($item);
				}

				return false;
			});

			if (A.settings.hashNavigation) {

				$(window).on('hashchange', function(e, initial) {
					var speed = initial ? 0 : A.settings.speed,
							$item = A.getItemByHash();

					A.expand($item, speed, function() {
						if (initial) {
							// Scroll to item
							$('html, body').animate({ scrollTop: $item.offset().top }, 500);
						}
					});
					return false;
				});

				$(window).trigger('hashchange', ['initial']);

			}

			if (A.settings.expanded && !A.getItemByHash().size()) {
				A.expand(A.$items.first());
			}
		},

		expand: function($item, speed, callback) {
			var A = this,
				$content = $item.find(A.settings.content),
				height;

			if($content.hasClass('animating')) return;

			A.$items.filter('.expanded').each(function() {
				A.contract($(this));
			});

			$content.addClass('visible');
			height = $content.height();

			$content
				.css({'height': 0})
				.addClass('animating')
				.stop()
				.animate({'height': height}, speed, function() {
					$content
						.removeClass('animating')
						.css({'height': ''});
					$item.addClass('expanded');

					if (callback) {
						callback();
					}
				});

			A.toggleExpandedClass($item, 1);
		},

		contract: function($item, speed) {
			var A = this,
					$content = $item.find(A.settings.content);

			if($content.hasClass('animating')) return;

			$content
				.addClass('animating')
				.stop()
				.animate({'height': 0}, speed, function() {
				$content
					.removeClass('visible animating')
					.css({'height': ''});

				$item.removeClass('expanded');
			});

			A.toggleExpandedClass($item, 0);
		},

		expandUsingHash: function($item) {
			var A = this,
					id = $item.find('>:first-child').attr('data-id'),
					currentHash = window.location.hash.replace('#', '');

			if (A.settings.hashNavigation && currentHash != id) {
				location.hash = id;
				return true;
			}
			return false;
		},

		getItemByHash: function() {
			var A = this,
					hash = window.location.hash.replace('#', '');

			return A.$el.find('[data-id="' + hash +'"]').closest(A.settings.item);
		},

		toggleExpandedClass: function($item, add) {
			var A = this;

			$.each(A.settings.addExpandedClass, function () {
				$item.find(this).toggleClass('expanded', add);
			});
		}

	};

	$.fn.accordion = function(options) {
		var args = Array.prototype.slice.call(arguments, 1),
			$this, data;

		return this.each(function() {
			$this = $(this);
			data = $this.data('accordion');

			if(!data) {
				$this.data('accordion', (data = new Accordion(this, options)));
			}
			if(typeof options === 'string') {
				data[options](args);
			}
		});
	};

	$.fn.accordion.Constructor = Accordion;

})(jQuery);
